var PaletteItemName;
(function(PaletteItemName) {
    PaletteItemName["torchRed"] = "torchRed";
    PaletteItemName["electricBlue"] = "electricBlue";
    PaletteItemName["business"] = "business";
    PaletteItemName["yolk"] = "yolk";
    PaletteItemName["broccoli"] = "broccoli";
    PaletteItemName["eggplant"] = "eggplant";
    PaletteItemName["tomato"] = "tomato";
    PaletteItemName["grey"] = "grey";
})(PaletteItemName || (PaletteItemName = {}));
var TypographyItemName;
(function(TypographyItemName) {
    TypographyItemName["TinyParagraph"] = "TinyParagraph";
    TypographyItemName["Paragraph"] = "Paragraph";
    TypographyItemName["LargeParagraph"] = "LargeParagraph";
    TypographyItemName["SmallCapsHeadline"] = "SmallCapsHeadline";
    TypographyItemName["SmallHeadline"] = "SmallHeadline";
    TypographyItemName["Subheadline"] = "Subheadline";
    TypographyItemName["Headline"] = "Headline";
    TypographyItemName["SuperHeadline"] = "SuperHeadline";
    TypographyItemName["HugeHeadline"] = "HugeHeadline";
})(TypographyItemName || (TypographyItemName = {}));

export { PaletteItemName, TypographyItemName };
